export const FETCHING_FEATURE = 'FETCHING_FEATURE';